/* eslint-disable no-unreachable */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */

import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import SecuredImage from 'modules/common/components/SecuredImage';
import { ModalContext } from 'App';
import Region from 'modules/common/address/Region';
import Province from 'modules/common/address/Province';
import Municipality from 'modules/common/address/Municipality';
import CmsContext from 'context/CmsContext';
import useFormValidator from 'useFormValidator';
import Select from 'react-select';
import { reactSelectCustomStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';

const RULES = {
  registry_number: 'required',
  first_name: 'required',
  last_name: 'required',
  death_date: 'required',
  volume: 'required',
  sex: 'required',
};

function DeathCertModal({
  createDeathCertificate,
  formData,
  getRoleList,
  setFormData,
  creating,
  recordData,
  updateDeathCertificate,
  syncToEs,
  getDeathCertificateList,
  showDeathCertificate,
  history,
  updating,
  syncing,
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');
  const validator = useFormValidator(formData, RULES);

  const field = _.pick(formData, [
    'registry_number',
    'first_name',
    'last_name',
    'death_date',
    'volume',
    'sex',
  ]);

  useEffect(() => {
    validator.validate();
  }, [Object.values(field).join(',')]);

  useEffect(() => {
    if (recordData) {
      setFormData({
        ...c.FORM_DATA,
        registry_number: _.get(recordData, 'attributes.registry_number') || '',
        first_name: _.get(recordData, 'attributes.first_name') || '',
        middle_name: _.get(recordData, 'attributes.middle_name') || '',
        last_name: _.get(recordData, 'attributes.last_name') || '',
        extension_name: _.get(recordData, 'attributes.extension_name') || '',
        death_date: _.get(recordData, 'attributes.death_date') || '',
        sex: _.get(recordData, 'attributes.sex') || '',
        volume: _.get(recordData, 'attributes.volume') || '',
        place_of_death_municipality_code:
          _.get(recordData, 'attributes.place_of_death_municipality_code') ||
          '',
      });
      return;
    }
    setFormData({
      ...c.FORM_DATA,
      place_of_death_municipality_code:
        _.get(CMS_VARIABLES, 'MUNICIPALITY_CODE') || '',
    });
  }, [recordData]);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const handleOnChangeSelect = (e, key) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const onUpload = (side) => (e) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      setFormData({
        ...formData,
        [`${side}`]: reader.result,
        [`${side}_file`]: file,
      });
    };

    reader.readAsDataURL(file);
  };

  const validateForm = () => {
    if (!validator.response.is_passed) return false;

    return true;
  };

  const handleOnSubmitAdd = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const formD = new FormData();

    for (const key in formData) {
      if (
        key !== 'front_page_file' &&
        key !== 'back_page_file' &&
        key !== 'front_page' &&
        key !== 'back_page'
      ) {
        formD.append(key, formData[key]);
      }
    }

    formD.append('front_page', _.get(formData, 'front_page_file'));
    formD.append('back_page', _.get(formData, 'back_page_file'));
    formD.set('first_name', _.get(formData, 'first_name').toUpperCase());
    formD.set('last_name', _.get(formData, 'last_name').toUpperCase());

    if (_.get(formData, 'middle_name') === undefined) {
      formD.set('middle_name', '');
    } else {
      formD.set('middle_name', _.get(formData, 'middle_name').toUpperCase());
    }

    createDeathCertificate(formD, (data) => {
      setModal({ isOpen: false });
      getDeathCertificateList();
      history.push(
        `/civil-registry/death-certificate/records-maintenance/${_.get(
          data,
          'data.id'
        )}`
      );
      showDeathCertificate(_.get(data, 'data.id'));
    });
  };

  const handleOnSubmitUpdate = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
    };

    args.first_name = args.first_name.toUpperCase();
    args.last_name = args.last_name.toUpperCase();
    args.middle_name = args.middle_name.toUpperCase();
    args.registry_number = args.registry_number.toUpperCase();
    args.volume = args.volume.toUpperCase();

    updateDeathCertificate(_.get(recordData, 'id'), args, ({ data }) => {
      getDeathCertificateList();
      setModal({ isOpen: false });
      showDeathCertificate(_.get(recordData, 'id'));
      syncToEs({ id: _.get(recordData, 'id') });
      history.push(
        `/civil-registry/death-certificate/records-maintenance/${_.get(
          data,
          'id'
        )}`
      );
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getRoleList();
  }, []);

  return (
    <Modal.Body>
      <form
        onSubmit={(e) =>
          !recordData ? handleOnSubmitAdd(e) : handleOnSubmitUpdate(e)
        }
      >
        <div className="row">
          <div className="col-12">
            <h4>Document&apos;s Owner Personal Information</h4>
          </div>

          <div className="form-input-group col-sm-12 col-md-6 col-lg-3 mb-2">
            <label htmlFor="registry_number" className="full-label mb-0">
              Registry Number: {validator.renderMessage('registry_number')}
            </label>
            <input
              placeholder="_"
              className="form-control text-uppercase"
              type="text"
              autoComplete="none"
              name="registry_number"
              id="registry_number"
              onChange={handleOnChange}
              value={_.get(formData, 'registry_number') || ''}
            />
          </div>

          <div className="form-input-group col-sm-12 col-md-6 col-lg-3 mb-2">
            <label htmlFor="first_name" className="full-label mb-0">
              First Name: {validator.renderMessage('first_name')}
            </label>
            <input
              placeholder="_"
              className="form-control text-uppercase"
              type="text"
              autoComplete="none"
              name="first_name"
              id="first_name"
              onChange={handleOnChange}
              value={_.get(formData, 'first_name') || ''}
            />
          </div>

          <div className="form-input-group col-sm-12 col-md-6 col-lg-3 mb-2">
            <label htmlFor="middle_name" className="full-label mb-0">
              Middle Name:
            </label>
            <input
              placeholder="_"
              className="form-control text-uppercase"
              type="text"
              autoComplete="none"
              name="middle_name"
              id="middle_name"
              onChange={handleOnChange}
              value={_.get(formData, 'middle_name') || ''}
            />
          </div>

          <div className="form-input-group col-sm-12 col-md-6 col-lg-3 mb-2">
            <label htmlFor="last_name" className="full-label mb-0">
              Last Name: {validator.renderMessage('last_name')}
            </label>
            <input
              placeholder="_"
              className="form-control text-uppercase"
              type="text"
              autoComplete="none"
              name="last_name"
              id="last_name"
              onChange={handleOnChange}
              value={_.get(formData, 'last_name') || ''}
            />
          </div>

          <div className="form-input-group col-sm-12 col-md-6 col-lg-3 mb-2">
            <label className="full-label mb-0">Extension Name:</label>
            <Select
              styles={reactSelectCustomStyle}
              placeholder="Select"
              value={
                c.EXTENSION_NAMES.find(
                  (item) =>
                    _.get(formData, 'extension_name') === _.get(item, 'value')
                ) || ''
              }
              onChange={(e) => handleOnChangeSelect(e, 'extension_name')}
              options={c.EXTENSION_NAMES}
              components={{
                IndicatorSeparator: () => null,
              }}
            />
          </div>

          <div className="form-input-group col-sm-12 col-md-6 col-lg-3 mb-2">
            <label className="full-label mb-0">
              Date of Death {validator.renderMessage('death_date')}
            </label>
            <DateInputPicker
              className="form-control"
              onChange={handleOnChangeDate('death_date')}
              value={_.get(formData, 'death_date') || ''}
              maxDate={new Date()}
            />
          </div>

          <div className="form-input-group col-sm-12 col-md-6 col-lg-3 mb-2">
            <label className="full-label mb-0">
              Sex {validator.renderMessage('sex')}
            </label>
            <Select
              styles={reactSelectCustomStyle}
              placeholder="Select"
              value={
                c.GENDER.find(
                  (item) => _.get(formData, 'sex') === _.get(item, 'value')
                ) || ''
              }
              onChange={(e) => handleOnChangeSelect(e, 'sex')}
              options={c.GENDER}
              components={{
                IndicatorSeparator: () => null,
              }}
            />
          </div>

          <div className="form-input-group col-sm-12 col-md-6 col-lg-3 mb-2">
            <label htmlFor="volume" className="full-label mb-0">
              Volume: {validator.renderMessage('volume')}
            </label>
            <input
              placeholder="_"
              className="form-control text-uppercase"
              type="text"
              autoComplete="none"
              name="volume"
              id="volume"
              onChange={handleOnChange}
              value={_.get(formData, 'volume') || ''}
            />
          </div>

          <div className="form-input-group col-sm-12 col-md-6 col-lg-3 mt-auto">
            <label className="full-label mb-0 ">
              Place of Death
              <br />
              Region
            </label>
            <Region
              isDisabled
              styles={reactSelectCustomStyle}
              // name="region_code"
              value={_.get(CMS_VARIABLES, 'REGION_CODE') || ''}
              onChange={() => {}}
            />
          </div>
          <div className="form-input-group col-sm-12 col-md-6 col-lg-3 mt-auto">
            <label className="full-label mb-0">Province</label>
            <Province
              isDisabled
              styles={reactSelectCustomStyle}
              // name="province_code"
              value={_.get(CMS_VARIABLES, 'PROVINCE_CODE') || ''}
              regionCode={_.get(CMS_VARIABLES, 'REGION_CODE') || ''}
              onChange={() => {}}
            />
          </div>
          <div className="form-input-group col-sm-12 col-md-6 col-lg-3 mt-auto">
            <label className="full-label mb-0">City/Municipality</label>
            <Municipality
              isDisabled
              styles={reactSelectCustomStyle}
              name="place_of_death_municipality_code"
              value={_.get(formData, 'place_of_death_municipality_code') || ''}
              regionCode={_.get(CMS_VARIABLES, 'REGION_CODE') || ''}
              provinceCode={_.get(CMS_VARIABLES, 'PROVINCE_CODE') || ''}
              onChange={() => {}}
            />
          </div>

          {!recordData ? (
            <>
              <div className="col-12 mt-4">
                <h4>Death Certificates</h4>
              </div>

              <div className="col-sm-12 col-md-6">
                <label>Front</label>
                <div className="col-12 bc-image ">
                  <SecuredImage
                    className="img-proportion"
                    onContextMenu={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                    alt="BC"
                    src={_.get(formData, 'front_page') || ImagePlaceholder}
                  />
                </div>
                <div className="col-12 ">
                  <input
                    style={{ width: '100%' }}
                    type="file"
                    className="file-elip btn border border-primary btn-light btn-round font-weight-bold px-4 ml-auto"
                    onChange={onUpload('front_page')}
                  />
                </div>
              </div>

              <div className="col-sm-12 col-md-6">
                <label>Back</label>
                <div className="col-12 bc-image ">
                  <SecuredImage
                    className="img-proportion"
                    onContextMenu={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                    alt="BC"
                    src={_.get(formData, 'back_page') || ImagePlaceholder}
                  />
                </div>
                <div className="col-12 ">
                  <input
                    style={{ width: '100%' }}
                    type="file"
                    className="file-elip btn border border-primary btn-light btn-round font-weight-bold px-4 ml-auto"
                    onChange={onUpload('back_page')}
                  />
                </div>
              </div>
            </>
          ) : null}
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={creating || updating || syncing}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating || updating || syncing ? (
                <i className="fa fa-spin fa-spinner" />
              ) : (
                `Submit`
              )}
            </span>
          </button>
          <button
            disabled={creating || updating || syncing}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

DeathCertModal.defaultProps = {
  recordData: undefined,
};

DeathCertModal.propTypes = {
  setFormData: PropTypes.instanceOf(Function).isRequired,
  getDeathCertificateList: PropTypes.instanceOf(Function).isRequired,
  createDeathCertificate: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  recordData: PropTypes.instanceOf(Object),
  showDeathCertificate: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  updating: PropTypes.bool.isRequired,
  syncing: PropTypes.bool.isRequired,
  updateDeathCertificate: PropTypes.instanceOf(Function).isRequired,
  syncToEs: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_USER_MANAGEMENT) > -1,
  updating: api.loading.indexOf(c.UPDATE_USER_MANAGEMENT) > -1,
  syncing: api.loading.indexOf(c.SYNC_TO_ES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(DeathCertModal);
